import { AvatarSize } from '@eventbrite/eds-avatar';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { LISTING_HEAP_IDS } from '../../constants';
import { useFeatureFlags, useScrollOnCommand } from '../../contexts';
import { EventDetailsSectionTitle } from '../EventDetails/EventDetails';
import { useTrackComponent } from '../hooks/useTrackComponent';
import { LSClickableAvatarWithBadge } from '../_shared/OrganizerInfo/OrganizerTrustSignalInfo/ListingsAvatarWithBadge';
import { ActionBar } from './components/ActionBar/ActionBar';
import { Info } from './components/Info/Info';
import styles from './NewOrganizerPanel.module.scss';

export type NewOrganizerPanelProps = {
    captchaKey: string;
    isAuthenticated: boolean;
    gaCategory: string;
    isMobile: boolean;
};

export const NewOrganizerPanel = ({
    captchaKey,
    isAuthenticated,
    gaCategory,
    isMobile,
}: NewOrganizerPanelProps) => {
    const featureFlags = useFeatureFlags();
    const ref = React.useRef<HTMLDivElement>(null);
    useScrollOnCommand(ref, 'organizerPanel');

    useTrackComponent({
        ref: ref,
        heap: {
            eventName: LISTING_HEAP_IDS.NEW_ORGANIZER_PANEL_INFO_VIEW,
            eventBucketLabel: 'Views on the Organizer panel section',
        },
    });

    return (
        <div ref={ref}>
            <EventDetailsSectionTitle>
                <h2>{gettext('Organized by')}</h2>
            </EventDetailsSectionTitle>
            <div className={styles.NewOrganizerPanelContainer}>
                <div className={styles.infoWrapper}>
                    <div className={styles.avatarContainer}>
                        <LSClickableAvatarWithBadge
                            featureFlags={featureFlags}
                            isMobile={isMobile}
                            avatarSize={AvatarSize.medium}
                            verifiedBadgeIconSize={28}
                        />
                    </div>
                    <Info />
                </div>
                <ActionBar
                    captchaKey={captchaKey}
                    isAuthenticated={isAuthenticated}
                    gaCategory={gaCategory}
                />
            </div>
        </div>
    );
};
